<template>
    <div class="limited-width-lg">
        <div class="container my-2">
            <div class="row">
                <div class="col-md-12">
                    <accordion-component
                            :content="
                                    [
                                        {
                                            title: 'login.loginPageBottomTitle',
                                            content: 'login.loginPageBottomText'
                                        }
                                    ]"
                            :prefix="'whyRegister'">
                    </accordion-component>
                </div>

                <div class="mt-4">
                    <div class="col-md-12">
                        <h2 class="text-center mb-4">{{ translate.login.dontHaveAccount }}</h2>
                    </div>

                    <div class="col-md-12 mb-4">
                        <div class="limited-width-sm px-3">
                            <a :href="regionRelativeUrl('/users/registration/')" class="btn btn-secondary btn-block">
                                {{ translate.login.register }}
                            </a>
                        </div>
                    </div>
                    <registration-features-component></registration-features-component>

                </div>

            </div>
        </div>
    </div>
</template>

<script>

import AccordionComponent from "@/components/global/AccordionComponent.vue";
import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";

export default {
    components: {AccordionComponent},
    computed: {
        ...mapState(['translate']),
    },
    mixins:[
        regionsUrlMixin,
    ],
}
</script>
